import store from '@/store'
import { includeArray } from '@/utils'

export default {
    inserted(el, binding, vnode){

        const { value } = binding;

        const access = store.getters['userInfo/uniqueAuth'];

        if(value && value instanceof Array && value.length && access && access.length){
            const isPermission = includeArray(value, access);

            if(!isPermission){
                el.parentNode && el.parentNode.removeChild(el);
            }
        }

    }
}